<template>
    <v-container>
        <v-layout column class="card">
            <v-form ref="form">
                <v-layout>
                    <v-flex xs2 mr-5>
                        <v-label>ID</v-label>
                        <v-text-field :rules="[rules.required,rules.notzero]"
                                      :disabled="edicao"
                                      v-input-filter="[filters.numeric]"
                                      maxlength="15"
                                      v-model="model.id_unidade_negocio"
                                      flat solo>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 mr-5>
                        <v-label>Código</v-label>
                        <v-text-field :rules="[rules.required,rules.notzero]"
                                      :disabled="edicao"
                                      v-input-filter="[filters.numeric]"
                                      maxlength="15"
                                      v-model="model.codigo"
                                      flat solo>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs8>
                        <v-label>Nome</v-label>
                        <v-text-field :rules="[rules.required]"
                                      v-input-filter="[filters.text]"
                                      v-uppercase
                                      maxlength="50"
                                      v-model="model.nome"
                                      flat solo></v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-layout mt-3>
                <v-flex xs2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import Filters from '../plugins/filters'
import { alert, error, sleep } from '../plugins/helpers'
import { events } from '../plugins/events'

const listagem = 'unidades_negocio'

export default {
  computed: {
    rules: () => Rules,
    filters: () => Filters
  },
  data: () => ({
    edicao: false,
    model: {
      id_unidade_negocio: '',
      codigo: '',
      nome: ''
    }
  }),
  methods: {
    salvar () {
      const form = this.$refs.form

      if (form.validate()) {
        (this.edicao
          ? this.$http.put(`/admin/unidadesnegocio/${this.model.id_unidade_negocio}`, this.model)
          : this.$http.post('/admin/unidadesnegocio', this.model))
          .then(() => {
            alert({
              text: `Unidade de negócio ${this.edicao ? 'alterada' : 'cadastrada'} com sucesso!`,
              buttons: {
                'OK': () => {
                  const id_usuario = this.$session.get('id_usuario')
                  events.$emit('atualizar-unidade', id_usuario)
                  this.$router.push({ name: listagem })
                }
              }
            })
          }).catch(err => {
            error(err, 'Não foi possível salvar as informações.')
          })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    }
  },
  mounted () {
    if ('id_unidade_negocio' in this.$route.params) {
      const id_unidade_negocio = this.$route.params['id_unidade_negocio']
      this.$http.get(`/admin/unidadesnegocio/${id_unidade_negocio}`)
        .then((r) => {
          this.edicao = true
          this.model = r.data
        }).catch(err => {
          error(err, 'Não foi possível recuperar as informações.')
        })
    }
  }
}
</script>

<style scoped>

</style>
